/* eslint-disable no-bitwise */

export default function stringToColor(string: string): number {
  let hash = 0;
  let i;
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % 7;
}
